export const SUBCATEGORY_NOT_IN_PERSONAL_PLAN = [184, 192, 577, 240];
export let LanguageSelectorLocation = /*#__PURE__*/function (LanguageSelectorLocation) {
  LanguageSelectorLocation["DESKTOP_HEADER"] = "desktop_header";
  LanguageSelectorLocation["MOBILE_NAV"] = "mobile_nav";
  return LanguageSelectorLocation;
}({});
export const PURCHASE_PRICE_TYPES = {
  individual_buyable: 'buyable_price',
  individual_shopping_buyable: 'buyable_cart_price',
  bundle: 'bundle_price',
  subtotal: 'subtotal_price',
  total: 'total_price'
};
//# sourceMappingURL=constants.js.map